import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { ICellEditorAngularComp } from '@ag-grid-community/angular';
import { ICellEditorParams } from '@ag-grid-community/core';
import { PASSWORD_VIEW } from '@frontend-site/shared/data';

@Component({
    selector: 'p-password-cell-renderer',
    template: `<input class="password-cell-input" #input type="password" [(ngModel)]="value" />`,
    styleUrls: ['./password-renderer.component.scss']
})
export class PasswordCellEditorComponent implements ICellEditorAngularComp, AfterViewInit {
    public value!: string;

    @ViewChild('input', { read: ViewContainerRef })
    public input!: ViewContainerRef;
    params!: ICellEditorParams<any, any>;
    tempValue!: string;

    ngAfterViewInit(): void {
        window.setTimeout(() => {
            this.input.element.nativeElement.focus();
        });
    }

    agInit(params: ICellEditorParams<any, any>): void {
        this.params = params;
        this.tempValue = this.params.value;
        if (this.params.value) {
            this.value = PASSWORD_VIEW;
        }
    }

    getValue(): any {
        return this.value;
    }
}
